import type { DeepString } from "@/lib/i18n";

/**
 * CatalogLoadMore - polskie tłumaczenia (wspólny standard paginacji "Wczytaj więcej").
 */
export const pl = {
  loadMore: "Wczytaj więcej",
  loading: "Wczytywanie...",
  /** `shown(20, 57)` -> "Pokazano 20 z 57". */
  shown: (shown: number, total: number) => `Pokazano ${shown} z ${total}`,
} as const;

export type CatalogLoadMoreTranslations = DeepString<typeof pl>;
